export default __webpack_public_path__ + "static/media/share-sm-icon.ec474511.svg";